export const adaptDocumentosSearch = (documento) => {
    return {
        idEvaluacion: documento?.idEvaluacion,
        idPaciente: documento?.idPaciente,
        paciente: documento?.paciente,
        codcliente: documento?.cod_cliente,
        cliente: documento?.cliente,
        fechaDesde: documento?.fechaDesde,
        fechaHasta: documento?.fechaHasta,
        modulo: documento?.modulo,
        idModulo: documento?.idModulo,
        idTipoModulo: documento?.idTipoModulo,
        aC: documento?.aC,
        eP: documento?.eP,
        cU: documento?.cU,
        c: documento?.c,
        rNH: documento?.rNH,
        rFK: documento?.rFK,
        p: documento?.p,
        v: documento?.v,
        dOC: documento?.dOC,
        pE: documento?.pE,
        pG: documento?.pG,
        nT: documento?.nT,
        fN: documento?.fN,
        pS: documento?.pS,
        kN: documento?.kN,
        tOC: documento?.tOC,
        aSS: documento?.aSS,
        eV: documento?.eV,
        rCP: documento?.rCP,
        pSI: documento?.pSI,
        cantCnx: documento?.cantCnx,
        cantCnxPE: documento?.cantCnxPE,
        cantCnxVE: documento?.cantCnxVE,
        cantBolsas: documento?.cantBolsas
    }
}

export const adaptDocumentosSearchArray = (
    documentos
) => {
    return structuredClone(documentos?.documentosSearch.valorEsperado)
        ?.map(documento => adaptDocumentosSearch(documento));
}